import React from "react";
import { Box, Container, Typography, Grid, Avatar } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ImgPath from "../../Constants/Imgs";

const reviews = [
  {
    name: "John",
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,`,
    img: ImgPath.ReviewIcon,
  },
  {
    name: "John",
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,`,
    img: ImgPath.ReviewIcon,
  },
  {
    name: "John",
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    img: ImgPath.ReviewIcon,
  },
  {
    name: "John",
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
    img: ImgPath.ReviewIcon,
  },
  {
    name: "John",
    text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's`,
    img: ImgPath.ReviewIcon,
  },
];

const ReviewSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box
      component="section"
      className="review-section section-wrap"
      sx={{ py: 6 }}
    >
      <Container>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          className="section-heading review-title"
        >
          Why Customer Love Us
        </Typography>
        <Slider {...settings}>
          {reviews.map((review, index) => (
            <Box key={index} className="item" px={2}>
              <Box
                className="review-card"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#fff",
                  p: 3,
                  textAlign: "center",
                  minHeight: 320, // 🔧 Ensures consistent card height
                  boxShadow: "0px 4px 10px 2px rgba(0, 0, 0, 0.25)",
                  transition: "0.5s ease-out",
                  "&:hover": {
                    transform: "translateY(-10px) scale(1.02)",
                    boxShadow: "0 20px 30px rgba(136, 136, 136, 0.25)",
                  },
                }}
              >
                <Avatar
                  src={review.img}
                  alt={review.name}
                  sx={{ width: 80, height: 80, mb: 2 }}
                />
                <Typography variant="h6" className="review-heading">
                  {review.name}
                </Typography>
                <Typography variant="body2" className="review-text">
                  {review.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Slider>
      </Container>
    </Box>
  );
};

export default ReviewSection;
